import { Stack, styled, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { ITemplateDTO, getOnlyEmailTemplates } from 'wisestep-api';
import { Spinner, IUserDTO } from 'wisestep-base';

import { useUserContext } from '../../../context';
import CreateTemplate, {
  CreateTemplateProps,
} from '../../emailSettings/components/templates/CreateTemplate';
import { getFavouredTemplatesFirst } from '../helper/TemplateSettingsHelper';

import NoTemplateCard from './NoTemplateCard';
import TemplateListingTable from './TemplateListingTable';

const Styles = styled(Stack)({ padding: '0', gap: 0.5 });

const EmailTemplateSettings = () => {
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);
  const handleDrawer = () => setShowCreateTemplate(true);
  const closeDialog = () => setShowCreateTemplate(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const [flagType, setFlagType] = useState<CreateTemplateProps['variant']>('new');
  const [template, setTemplate] = useState<ITemplateDTO[]>([]);
  const [editOrCloneData, setEditOrCloneData] = useState<ITemplateDTO>();
  const [loadPage, setLoadPage] = useState<boolean>(false);
  const [hasData, setHasData] = useState<boolean>(false);

  useEffect(() => {
    (async function () {
      const getUserDefinedTemplatesReq = await getOnlyEmailTemplates();
      if (getUserDefinedTemplatesReq.data) {
        setHasData(true);
        setTemplate(getFavouredTemplatesFirst(getUserDefinedTemplatesReq.data, loggedInUser));
        setLoadPage(true);
      }
    })();
  }, [loggedInUser, refresh]);

  const getLatestData = () => {
    setRefresh(!refresh);
  };

  return (
    <>
      <Styles>
        <Grid direction="column">
          <Grid>
            {!loadPage ? (
              <Spinner />
            ) : !hasData ? (
              <NoTemplateCard
                onClick={() => {
                  setFlagType('new');
                  handleDrawer();
                }}
              />
            ) : (
              <TemplateListingTable
                templates={template}
                setEditOrCloneData={setEditOrCloneData}
                setFlagType={setFlagType}
                getLatestData={getLatestData}
                handleDrawer={handleDrawer}
              />
            )}
          </Grid>
        </Grid>
      </Styles>
      {showCreateTemplate && (
        <CreateTemplate
          openDialog={showCreateTemplate}
          closeDialog={closeDialog}
          onEditOrCloneTemplate={editOrCloneData}
          variant={flagType}
          refreshData={getLatestData}
        ></CreateTemplate>
      )}
    </>
  );
};

export default EmailTemplateSettings;
